<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="item in list" :key="item" :title="item" />
    </van-list>
  </div>
</template>

<script>
export default {
  name: "inspectionRecord",

  props: {},

  data() {
    return {
       list: [],
      loading: false,
      finished: false,
      getTable:{
          // limit: 10,
          // page: 1,
          workid:"",//当前行的id
        },
    };
  },

  components: {},

  created() {

  },

  mounted() {
      this.getWorkPolling()
  },

  methods: {
    getWorkPolling(){
       this.getTable.workid = this.$route.params.id
      this.$axios.post('/dform/workPolling/list',this.getTable)
        .then((res) => {
          if(res.data.code){
            //this.loading = false
            this.list = res.data.data.rows
            //this.pages.total = res.data.data.total
          }
        })
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // setTimeout(() => {
      //   for (let i = 0; i < 10; i++) {
      //     this.list.push(this.list.length + 1);
      //   }

      //   // 加载状态结束
      //   this.loading = false;

      //   // 数据全部加载完成
      //   if (this.list.length >= 40) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
  },

  computed: {},

  watch: {},
};
</script>

<style>
</style>
